import { Box, HStack, keyframes } from '@chakra-ui/react'
import Image from 'next/image'
import { LOGO_DURATION_SECONDS, LOGO_HEIGHT } from '../constants'

interface Logo {
  src: string
  alt: string
  width: number
  height: number
}

interface LogoCarouselProps {
  logos: Logo[]
  duration?: number
}

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

export function LogoCarousel({
  logos,
  duration = LOGO_DURATION_SECONDS,
}: LogoCarouselProps): React.ReactElement {
  const duplicatedLogos = [...logos, ...logos]

  return (
    <Box
      w="100%"
      overflow="hidden"
      py={0}
      position="relative"
      whiteSpace="nowrap"
      sx={{
        maskImage:
          'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
        WebkitMaskImage:
          'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
      }}
    >
      <HStack
        as="div"
        animation={`${scroll} ${duration}s linear infinite`}
        minWidth="fit-content"
        _hover={{ animationPlayState: 'paused' }}
        spacing={4}
      >
        {duplicatedLogos.map((logo, index) => (
          <Box
            key={index}
            position="relative"
            flexShrink={0}
            h={`${LOGO_HEIGHT}px`}
            w={`${(logo.width / logo.height) * LOGO_HEIGHT}px`}
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              layout="fill"
              objectFit="contain"
            />
          </Box>
        ))}
      </HStack>
    </Box>
  )
}
